module.exports = __webpack_public_path__ + "img/bg_mandala_01.88484237.jpg";